import React, { useRef, useState } from 'react';
import { Carousel } from 'primereact/carousel';
import { Button } from 'primereact/button';
import { Galleria } from 'primereact/galleria';
import FileService from '../service/FileService';
import { FileUpload } from 'primereact/fileupload';
import Constants from '../constants/Constants';
import { Dialog } from 'primereact/dialog';
import { Exhibition } from '../pages/exhibition/Exhibition';

const CustomFeaturedExhibitions = (props) => {

    console.log("CustomFeaturedExhibitions", props)

    const [activeIndex, setActiveIndex] = useState(0);


    const galleriaRef = useRef(null);


    const responsiveOptions = [
        {
            breakpoint: '1024px',
            numVisible: 5
        },
        {
            breakpoint: '768px',
            numVisible: 3
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];

    const itemTemplate = (item) => {
        return <div className='flex justify-content-center w-12 align-items-center flex-column'>
            <img src={FileService.inquireFilePath(item?.headerimageData?.file)} alt={"header"} style={{ maxWidth: 500, maxHeight: 600, display: 'block' }} onError={(e) => e.target.src = `/assets/layout/images/error_image.png`} />
            <div className={'text-3xl  font-700-regular pt-3 font-white'}>
                {item.exhibitionName}

            </div>

        </div>;
    }

    const thumbnailTemplate = (item) => {
        return <img src={FileService.inquireFilePath(item.headerCoverPath)} alt={item.name} style={{ display: 'block' }} onError={(e) => e.target.src = `/assets/layout/images/error_image.png`} />;
    }


    return (
        <div >
            <Galleria ref={galleriaRef} value={props.exhibits} responsiveOptions={responsiveOptions} numVisible={7} style={{ maxWidth: '850px' }}
                activeIndex={activeIndex} onItemChange={(e) => setActiveIndex(e.index)}
                circular fullScreen showItemNavigators showThumbnails={false} item={itemTemplate} thumbnail={thumbnailTemplate} />

            <div className="grid" style={{  }} >
                {
                    props.exhibits && props.exhibits.map((exhibit, index) => {
                        let imgEl =
                            <div className='featured-images' style={{
                                backgroundImage: `url(${FileService.inquireFilePath(exhibit?.headerimageData?.file)})`,

                            }}
                                onClick={
                                    () => {
                                        //  props.onAction(0);

                                        props.onSelectedExhibit(exhibit);

                                    }
                                } >
                                <div style={{

                                    flexDirection: 'column', // inner items will be added vertically
                                    flexGrow: 1,            // all the available vertical space will be occupied by it
                                    justifyContent: 'space-between', // will create the gutter between body and footer
                                    height: '100%',
                                    display: 'flex',
                                    background: 'linear-gradient(rgb(0,0,0,0), rgb(0, 0,0,0.7))',
                                    borderRadius: 20,
                                    padding: 10,

                                }}></div>

                            </div>

                        return (
                            <div className='m-2 ' key={index}>
                                <div className='text-center' style={{ borderRadius: 20, width: 185, height: 130 }}>
                                    {imgEl}

                                    <div className='text-xl  font-400-regular pl-1 pr-1  font-white' style={{
                                        ...props.labelStyle,
                                        marginTop: -45
                                    }}>
                                        {exhibit.exhibitionName}
                                    </div>
                                </div>

                            </div>
                        )
                    })
                }
                {
                    props.RenderAddPanel && props.RenderAddPanel()
                }



            </div>
        </div>
    );
};

export default CustomFeaturedExhibitions;
